import { Component, OnInit } from '@angular/core';
import { NavigationService } from '../../services/navigation.service';
import { RegistrationService } from '../../services/registration.service';
import { ListManagerService } from '../../services/list-manager.service';
import { EnrollmentService } from '../../services/enrollment.service';
import { ModalService } from 'src/app/services/modal.service';
import { HotelService } from '../../services/hotel.service';
import { GuestService } from 'src/app/services/guest.service';
import moment from 'moment-timezone';
import _ from 'lodash';
import { DateUtilityServiceService } from '../../services/date-utility-service.service';
import { VariablesService } from '../../services/variables.service';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ContactusComponent } from 'src/app/reusable-components/contactus/contactus.component';
import { ConstantsService } from 'src/app/services/constants.service';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { CreditcardService } from 'src/app/services/creditcard.service';
import { LineitemService } from 'src/app/services/lineitem.service';
import { RememberService } from 'src/app/services/remember.service';
import { MatIconModule } from '@angular/material/icon';
import { EnvironmentService } from 'src/app/services/environment.service';
import { CopyService } from 'src/app/services/copy.service';

@Component({
    templateUrl: './summary.component.html',
    standalone: false
})
export class SummaryComponent implements OnInit {

  isSubmitting = false;
  isError = false;
  hotelsLoaded = false;
  attendee;
  guests;
  enrollment;
  emailAddress;
  hotelList;
  dateRange;
  groupDays;
  preextend;
  postextend;
  hotelStay;
  workAddress: any;
  homeAddress: any;
  workPhone: any;
  homePhone: any;
  mobilePhone: any;
  emerContactMainPhone: any;
  emerContactAltPhone: any;
  adminContact: any;
  hotelSpecialRequests: any;
  hotelSmoking: any;
  personalDisplay: any;
  isRegComplete: any;
  shirtSize;
  shirtSizeValue;
  errorMsg;
  dietaryNeedDisplay;
  personalConsiderationsDisplay;
  mealList;
  personalConsiderationsList;
  pagesInSiteFlow: any;
  page: any;
  firstTime;
  firstTimeValue;
  isFormCompleted;
  whyAttend;
  showpayment = false;
  bestFeature;
  bestFeatureValue;
  bestFeatureFreeForm;
  bestFeatureFreeFormValue;
  bestFeatures;
  bestFeaturesSelections;
  programInfo;
  successMessage = false;
  ready = false;
  output:any = {
    showGlobals : false,
    config: "",
    enrollment:"",
    programKey:"",
    serviceURL:"",
    hideLimits:true,
    hideHeader:true
  };

  charges = {
    Conference: null,
    Hotel: null,
    Activity: null,
    Guest: null
  };
  payment;
  conferencePayment;
  guaranteecard;
  guaranteePayment;
  cards;
  hotelPayment;
  hotelcard;
  activityPayment;
  activitycard;
  guestPayment;
  guestcard;
  conferencecard;
  rememberme;
  isGDPR;
  partsAccountNum;
  starsID;
  dealerCode;
  accepRom;
  respHotel;
  accepAir;
  respAir;

  airPayment;
  airCard;

  p6Payment;
  p6CCard;
  CCollectionPaxRequired;
  //for many policies
  //check functions startandSetpolicies() and givemePolicyBox()
 // policiesandChecks={};
 // policies=["codeConduct","cancelPolicy","photoRelease","realID","l099"];// names musbe the same as variables.service


/*   codeConduct;
  codeConductBox;
  cancelPolicy;
  cancelPolicyBox;
  photoBox;
  photo; */
  private allSpaces=/\s/gm;
  ccObj={};
  titles={};
  order={};

  constructor(
    private navigationService: NavigationService,
    private registrationService: RegistrationService,
    private listService: ListManagerService,
    private enrollmentService: EnrollmentService,
    public modalService: ModalService,
    private hotelService: HotelService,
    private dateService: DateUtilityServiceService,
    private variablesService: VariablesService,
    private guestService: GuestService,
    private location: Location,
    private router: Router,
    public dialog: MatDialog,
    public Constants: ConstantsService,
    private configurationService: ConfigurationService,
    private creditCardService: CreditcardService,
    private lineItemService: LineitemService,
    private rememberService: RememberService,
    private environmentService: EnvironmentService,
    private copyService: CopyService,
  ) {
    this.attendee = this.registrationService.getAttendee({});
    this.guests = this.registrationService.getGuests({});
    this.enrollment = this.registrationService.getEnrollment({});
  //  this.startandSetpolicies();
    
    this.workAddress = this.registrationService.getAddress(this.attendee, "WORK", {});
    this.homeAddress = this.registrationService.getAddress(this.attendee, "HOME", {});
    this.workPhone = this.registrationService.getPhone(this.attendee, "WORK", {});
    this.homePhone = this.registrationService.getPhone(this.attendee, "HOME", {});
    this.mobilePhone = this.registrationService.getPhone(this.attendee, "MOBILE", {});
    this.emailAddress = this.registrationService.getEmail(this.attendee, "BUSINESS", {});

    //this.dealerCode = this.registrationService.getVariable(this.attendee,variablesService.VARIABLE.dealerCode.ID,{});
    this.partsAccountNum= this.registrationService.getVariable( this.attendee, this.variablesService.VARIABLE.partsAcctNo.ID, {} );
    //this.starsID= this.registrationService.getVariable( this.attendee, this.variablesService.VARIABLE.starsID.ID, {} );
    this.accepRom = registrationService.getVariable(this.attendee, variablesService.VARIABLE.accepRom.ID, {});
    this.respHotel = registrationService.getVariable(this.attendee, variablesService.VARIABLE.respHotel.ID, {});
    this.accepAir = registrationService.getVariable(this.attendee, variablesService.VARIABLE.accepAir.ID, {});
    this.respAir = registrationService.getVariable(this.attendee, variablesService.VARIABLE.respAir.ID, {});

    this.emerContactMainPhone = this.registrationService.getEmergencyContactPhone(this.attendee, "DTPHONE", {});
    this.emerContactAltPhone = this.registrationService.getEmergencyContactPhone(this.attendee, "ALTPHONE", {});
    this.adminContact = this.registrationService.getAdminContact({});
    this.hotelSpecialRequests = this.enrollment.HotelSpecialRequests;
    this.hotelSmoking = this.attendee.HotelSmoking;
    this.output.enrollment = this.enrollment;
    this.configurationService.fetchConfig().then( conf =>{
      this.output.config = conf;
      this.output.programKey = this.environmentService.getProgramKey();
      this.output.baseURL = this.environmentService.getEnvironmentUrl("");
      this.output.actEndpoint = "service/webactivity";
      this.ready=true;
      console.log("activity output object ready");
    });

    this.cards = this.creditCardService.cards;
    this.lineItemService.getAllLineItems().subscribe(data=>{
      if(data.length>0){
        this.showpayment = true;
      }else{
        this.configurationService.fetchConfig().then((config: any) => {
          if(config.hotelGuarantee && this.registrationService.getEnrollment({}).HotelNeeded == true){
            this.showpayment = true;
          }else if(config.chargeExtensions && this.registrationService.getEnrollment({}).HotelNeeded == true && this.registrationService.getEnrollment({}).$mtcExtension){
            this.showpayment = true;
          }else if(this.showCardCollection()){
            this.showpayment = true;
          }else if( this.showAirfareGuarantee() || this.showHotelGuarantee()){
             this.showpayment = true;
          }
        });
      }
    });
    this.registrationService.getParticipant([]).forEach(pax=>{
      this.getDisplayName(pax);
    });   
    /*
    this.payment = this.registrationService.getPayment([]);
    this.hotelPayment = this.registrationService.getCreditCard(this.payment, "Hotel", undefined);
    this.hotelcard = this.hotelPayment && this.hotelPayment.MediaType === "CREDITCARD" ? _.filter(this.cards, { "ReferenceKey": this.hotelPayment.ReferenceKey })[0] : undefined;

    this.airPayment = this.registrationService.getCreditCard(this.payment, "Air", undefined);
    this.airCard = this.airPayment && this.airPayment.MediaType === "CREDITCARD" ? _.filter(this.cards, { "ReferenceKey": this.airPayment.ReferenceKey })[0] : undefined;

    this.p6Payment = this.registrationService.getCreditCard(this.payment, "CCollection", undefined);
    this.p6CCard = this.p6Payment && this.p6Payment.MediaType === "CREDITCARD" ? _.filter(this.cards, { "ReferenceKey": this.p6Payment.ReferenceKey })[0] : undefined;
    */

    this.isRegComplete = this.registrationService.isRegistrationComplete();

    this.listService.getMealPreferenceList().then(list => {
      this.mealList = list;

      if (this.attendee.DietaryNeed) {
        this.dietaryNeedDisplay = _.filter(this.mealList, { "code": this.attendee.DietaryNeed })[0].name;
      }
    });

    this.listService.getDisabilityList().then(list => {
      this.personalConsiderationsList = list;

      if (this.attendee.DisabilityType) {
        var temp;
        var final = "";
        let includeOther=false;
        for (var x = 0; x < this.attendee.DisabilityType.length; x++) {
          temp = _.filter(this.personalConsiderationsList, { "code": this.attendee.DisabilityType[x] })[0].name;
          if (temp === "Other"){
            includeOther=true;
            final = final + temp + " - " + this.attendee.PersonalConsiderations;
          }
          else
            final = final + temp;
          if (this.attendee.DisabilityType.length > 0 && x !== this.attendee.DisabilityType.length - 1) {
            final = final + ", "
          }
        }
        if(this.attendee.DisabilityType.length>0 && !includeOther && this.attendee.PersonalConsiderations  && (this.attendee.PersonalConsiderations.replace(this.allSpaces,'').length>0)){
          final = final + ", " + this.attendee.PersonalConsiderations;
        }
        if(this.attendee.DisabilityType.length===0 && this.attendee.PersonalConsiderations){
          final = this.attendee.PersonalConsiderations;
        }

        this.personalConsiderationsDisplay = final;
      }
    });

    this.listService.getPrivacyPolicyCountryList().then(list => {
      if(!this.enrollment.PrivacyPolicy) {
        this.enrollment.PrivacyPolicy = false;
      }
      this.isGDPR = false;
      for(let country of list) {
        if(country.code === this.attendee.ResidenceCountryISOCode) {
          this.isGDPR = true;
        }
      }
    });

    this.hotelStay = this.registrationService.getHotel([]);
    //check if hotel booking
    this.hotelList = { locked: false };
    if (this.enrollment.HotelNeeded) {
      this.hotelService.getHotelList().then(list => {
        this.hotelList = list;
        this.hotelsLoaded = true;
      });
    }    
  }

 /*  startandSetpolicies(){
    for (let index = 0; index < this.policies.length; index++) {
      let policy= this.policies[index];
      this.policiesandChecks[policy]={
        paxVar:"",
        check:"",
      }
      this.policiesandChecks[policy].paxVar=this.registrationService.getVariable(this.attendee, this.variablesService.VARIABLE[policy].ID, {});
      if(this.policiesandChecks[policy].paxVar.Value==="Yes"){
        this.policiesandChecks[policy].check = true;
      }
    }
    //console.log("proto: ",this.policiesandChecks);
  } */

 /*  givemePolicyBox(policy){
    return this.policiesandChecks[policy].check;
  } */

  detectAndGroupCards(){
    this.payment = this.registrationService.getPayment([]);
    this.payment.forEach(cc=>{
        if(cc.ReferenceKey && !this.ccObj.hasOwnProperty(cc.ReferenceKey)){
        this.ccObj[cc.ReferenceKey]=[cc.Category];
      }else{
        this.ccObj[cc.ReferenceKey].push(cc.Category);
      }
    });

  }

  getKeys(obj){
    return Object.keys(obj);
  }

  getCardTitles(ccKeytoEval){
  //console.log("arraytoEval: ", ccKeytoEval);
  
  //console.log("types allowed: ", this.order);
    let ccGroup= this.ccObj[ccKeytoEval];
    let title=[];
    ccGroup.forEach(ccType=>{
      if(this.order[ccType]) title.push(this.titles[ccType]);
    });
    return title.join(' & ');
  }

  someCCisAllowed(ccKeytoEval){
    let ccGroup= this.ccObj[ccKeytoEval];
    let someAllow=false;
    ccGroup.forEach(ccType=>{
      if(this.order[ccType]) someAllow=true;
    });
    return someAllow;
  }

  getDisplayName(participant) {
    var returnValue = "";
    this.listService.getPrefixValue(participant.Prefix).then(data=>{
      var prefix = data.name;
      console.log(data);
      console.log(prefix);
      if(prefix){
        returnValue = prefix + " ";
      }
      if (participant.FirstName) {
        returnValue += participant.FirstName + " ";
      }
      if (participant.MiddleName && !participant.NoMiddleNameFlag) {
        returnValue += participant.MiddleName + " ";
      }
      if (participant.LastName) {
        returnValue += participant.LastName + " ";
      }
      this.listService.getSuffixValue(participant.Suffix).then(data=>{
        var suffix = data.name;
        if(suffix && suffix !== "(None)"){
          returnValue += suffix;
        }
        if (returnValue.length <= 1) {
          returnValue = "Personal Information";
        } else {
          returnValue = returnValue.trim();
        }
        participant.$mtcDisplayName = returnValue;
      });
    });

  }


  siteFlowContains(page) {
    let index = 0; let found;
    if (this.pagesInSiteFlow) {
      for (index; index < this.pagesInSiteFlow.length; index++) {
        found = false;

        this.pagesInSiteFlow[index].forEach((entry) => {
          if (entry == '/' + page) {
            found = true;
          }
        });
        if (found) {
          break;
        }
      }
      return found;
    }
  };

  ngOnInit(): void {
    this.configurationService.fetchConfig().then((data: any) => {
      this.programInfo = data;
      this.CCollectionPaxRequired = data.paymentCCC;
      this.navigationService.getNavigationList().then(pagelist => {
        this.pagesInSiteFlow = pagelist;
        if(this.siteFlowContains('payment')) this.detectAndGroupCards();
      });
      this.titles={
        Hotel: data.copy.label.HOTEL.guarantee,
        Air: data.copy.html.Airfare_Costs.summAirGuarant,
        Guarantee: data.copy.html.CCCollection.title,
      };
      this.order={
        Hotel: this.showHotelGuarantee(),
        Air: this.showAirfareGuarantee(),
        Guarantee: this.showCardCollection(),
      };
    });
    if (this.enrollment.$mtcUpdateSuccess) {
      this.successMessage = true;
      this.enrollment.$mtcUpdateSuccess = false;
    }

    for (const key of _.keys(this.charges)) {
      this.lineItemService.getLineItems(key).subscribe({
        next: data => {
          this.charges[key] = _.reduce(data, (sum, n) => {
            return parseFloat(sum) + parseFloat(n);
          });
          },
            error: error => {
              this.Constants.ALERT_POLICY.CONTACT_SUPPORT
            }
      });
    }

    if( this.attendee.hasOwnProperty("DietaryConsiderations") && !(this.attendee.DietaryConsiderations.replace(this.allSpaces,'').length > 0))this.attendee.DietaryConsiderations=null;

    //when user returns to the registration summary page after summit, Ln:212 DisabilityType variable does not exist
    if( !this.attendee.hasOwnProperty("DisabilityType") && (this.attendee.PersonalConsiderations.replace(this.allSpaces,'').length > 0))this.attendee.DisabilityType=[];


  }

  getGuestDiet(guest) {
    if (guest && this.mealList) {
      if (guest.DietaryNeed) {
        return _.filter(this.mealList, { "code": guest.DietaryNeed })[0].name;
      }
    }
  }

  getGuestTypeDisplay(guest) {
    if (guest) {
      return this.guestService.getTypeDisplay(guest);
    }
  }

  getGuestADAPersonal(guest) {
    if (guest && this.personalConsiderationsList) {
      if(!guest.hasOwnProperty('DisabilityType')){
        guest.DisabilityType=[];
      }

      if (guest.DisabilityType) {
        var temp;
        var final = "";
        let includeOther=false;
        for (var x = 0; x < guest.DisabilityType.length; x++) {
          temp = _.filter(this.personalConsiderationsList, { "code": guest.DisabilityType[x] })[0].name;
          if (temp === "Other"){
            includeOther=true;
            final = final + temp + " - " + guest.PersonalConsiderations;
          }
          else
            final = final + temp;
          if (guest.DisabilityType.length > 0 && x !== guest.DisabilityType.length - 1) {
            final = final + ", "
          }
        }
        if(guest.DisabilityType.length>0 && !includeOther && guest.PersonalConsiderations){
          final = final + ", " + guest.PersonalConsiderations;
        }
        if(guest.DisabilityType.length===0 && guest.PersonalConsiderations){
          final = guest.PersonalConsiderations;
        }

        return final;
      }
    }
  }

  printPage() {
    window.print();
  }

  openModal(copy, title, actionButtonText) {
    this.modalService.openModal(copy, title, actionButtonText);
  }

  openModalExternal(url, title, actionButtonText) {
    this.modalService.openModalExternal(url, title, actionButtonText);
  }

  getHotelsWithStays() {
    var hotelids = _.uniq(_.map(this.hotelStay, "Hotel"));
    var hotels = [];
    if (this.hotelList) {
      var self = this;
      hotelids.forEach((id)=> {
        var hotel = _.filter(self.hotelList.roomTypeList, { webHotelGroupID: id })[0];
        var hotelNights = self.getNightsAtHotel(hotel.webHotelGroupID);
        hotel.firstNight = hotelNights[0];
        hotels.push(hotel);
      });
    }
    return hotels;
  };

  getNightsAtHotel(hotelid) {
    this.hotelStay.forEach( (hotelnight) =>{
      if (moment.isMoment(hotelnight.Date)) {
        hotelnight.Date = hotelnight.Date.toDate();
      }
    });
    return _.orderBy((_.map(_.filter(this.hotelStay, { Hotel: hotelid }), "Date")));
  };

  getStatus(hotelobj, date) {
    var hotelnight;
    var testDate;

    if (moment.isMoment(date)) {
      testDate = date.toDate();
    } else {
      testDate = this.dateService.createMTCZoneDateTime(date).toDate();
    }
    var self = this;
    _.forEach(hotelobj.roomNightsListWithRate, (night) => {
      var nightDate = self.dateService.createMTCZoneDateTime(night.blockDate).toDate();
      var inputDate = testDate;
      if (nightDate.getTime() === inputDate.getTime()) {
        hotelnight = night;
      }
    });

    if (hotelnight.availabilityCode === 1) {
      //if night is not already booked.
      if (hotelnight.groupDateFlag === "GRP") {
        return "Confirmed";
      } else {
        return "Pending";
      }
    } else if (hotelnight.availabilityCode === 2) {
      return "Pending";
    } else if (hotelnight.availabilityCode === 3) {
      return "Confirmed";
    }
  };

  editAttendee() {
    if (this.isRegComplete) {
      this.dialog.open(ContactusComponent, { panelClass: 'forgot-dialog-container' });
    }else{
      this.router.navigate(['attendee']);
    }
    
  }
  editGuest(guest) {
    if (this.isRegComplete && guest) {
      //this.guestService.selectGuest(guest);
      this.dialog.open(ContactusComponent, { panelClass: 'forgot-dialog-container' });
    }else{
      this.router.navigate(['guest']);
    }
  }
  editDemographics() {
    this.router.navigate(['demographics']);
  }
  editHotel() {
    if (this.isRegComplete || this.hotelList.locked) {
      this.dialog.open(ContactusComponent, { panelClass: 'forgot-dialog-container' });
    }
    else {
      if (this.programInfo) {
        if (this.programInfo.hotelpackage) {
          this.router.navigate(['hotelpackage']);
        } else if (this.programInfo.hotelBooking) {
          this.router.navigate(['hotelbooking']);
        } else {
          this.router.navigate(['hotel']);
        }
      }
    }
  }
  editTravel() {
    if (this.isRegComplete) {
      this.dialog.open(ContactusComponent, { panelClass: 'forgot-dialog-container' });
    }
    else {
      this.router.navigate(['travel']);
    }
  }
  editGuestTravel(guest) {
    if (this.isRegComplete) {
      this.dialog.open(ContactusComponent, { panelClass: 'forgot-dialog-container' });
    }
    else {
      this.guestService.selectGuest(guest);
      this.router.navigate(['guest-travel']);
    }
  }
  editSessions() {
    if (this.isRegComplete) {
      this.dialog.open(ContactusComponent, { panelClass: 'forgot-dialog-container' });
    }
    else {
      this.router.navigate(['activity']);
    }
  }

  /* policyChange(policy,checkVal){
    //console.log(" >>"+policy+" : "+checkVal);
    this.policiesandChecks[policy].check=checkVal;
    if(checkVal){
      this.policiesandChecks[policy].paxVar.Value = "Yes";
    }else{
      this.policiesandChecks[policy].paxVar.Value = "";
    }
  } */


  /**
  * @function editPayment
  * @description Sets activity path to payment page.
  */
  editPayment() {
    if (this.isRegComplete) {
      this.dialog.open(ContactusComponent, { panelClass: 'forgot-dialog-container' });
    }else{
      this.router.navigate(['payment']);
    }
    
  }

  phoneNoRipApart(phoneChunk){
    phoneChunk.forEach(phone => {
      if ( phone ) {
        if ( phone.AreaCityCode ) {
          if ( phone.AreaCityCode.length > 3 ) {
            let areaCityCode = phone.AreaCityCode.substring(0,3);
            let phoneNo = phone.AreaCityCode.substring(3);
            phone.AreaCityCode = areaCityCode;
            phone.PhoneNo = phoneNo;
          }
        }
      }

    });
  }

  checkDisabilityType(person){
    let check = false;
    if(person.hasOwnProperty("DisabilityType") && person.DisabilityType.length>0){
      check=true;
    }
    if(person.hasOwnProperty("PersonalConsiderations") && person.PersonalConsiderations.replace(this.allSpaces,'').length > 0){
      check=true;
    }
    
    return check;
  }


  forward(form) {
    if (!this.isSubmitting) {
    this.isFormCompleted = true;
    this.isSubmitting = true;
    this.errorMsg = undefined;

    this.enrollment.Participant.forEach(part => {
      if ( part.Phone ) {
        this.phoneNoRipApart(part.Phone);
      }
      if ( part.EmergencyContact) {
        this.phoneNoRipApart(part.EmergencyContact.EmergencyContactPhone);
      }
    });

    if ( this.enrollment.AdminContact.AdminContactPhone ) {
      this.phoneNoRipApart(this.enrollment.AdminContact.AdminContactPhone);
    }
    
    /* if () { */
    if (form.valid ) {
      if (this.enrollment.AgreedToTermsAndConditions) {
        this.enrollment.ResponsibilityStatement = true;
      }
      if (this.attendee.TravelType === undefined) {
        this.attendee.TravelType = 'UNK';
      }

      this.enrollmentService.createEnrollment(this.registrationService.getEnrollment({})).then(() => {
        if(this.rememberme){
          this.rememberService.setCookie(this.registrationService.getEnrollment({}).$mtcConfirmationCode, this.emailAddress.EmailAddress);
        }
        this.router.navigate(['acknowledgement']);
      }, (err) => {
        this.isSubmitting = false;

        this.errorMsg = "Error while submitting your registration.";
      });
      // this.navigationService.forward();
    } else {
      this.isError = true;
      this.isSubmitting = false;
    }
    //this.navigationService.forward();
    /* } else {
      this.isError = true;
      this.isSubmitting = false;
    } */
    }
  }

  showHotelGuarantee(){
    let accepRom = this.registrationService.getVariable(this.attendee, this.variablesService.VARIABLE.accepRom.ID, {});
    let show=false;
    let extending= ( (this.registrationService.getEnrollment({}).HotelCheckInDate < this.programInfo.arrivalDate) || (this.registrationService.getEnrollment({}).HotelCheckOutDate > this.programInfo.departureDate));

    if(this.attendee.PAXTypeNo!=4 && this.programInfo.hotelGuarantee && this.enrollment.HotelNeeded ) show= true;
    if(this.attendee.PAXTypeNo==4 && this.programInfo.hotelGuarantee && this.enrollment.HotelNeeded && ( extending || accepRom.Value==='No' ))  show= true;
    return show;
  }

  showAirfareGuarantee(){
    let accepAir = this.registrationService.getVariable(this.attendee, this.variablesService.VARIABLE.accepAir.ID, {});
    let show=false;
    if(this.attendee.PAXTypeNo==4 && this.attendee.TravelType === this.Constants.TRAVEL_TYPES.FLY && accepAir.Value==='No')  show= true;
    return show;
  }

  showCardCollection(){
    return this.CCollectionPaxRequired.includes(this.attendee.PAXTypeNo)
  }
}
